import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const HoaScroll = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div
            className={`fixed bottom-5 right-5 bg-blue-900 text-white border-none rounded-md p-2 cursor-pointer transition-opacity duration-300 ease-in-out hover:opacity-80 ${isVisible ? 'block' : 'hidden'
                }`}
            onClick={scrollToTop}
        >
            <FaArrowUp className="text-xl text-white" />
        </div>
    );
};

export default HoaScroll;